  <div class="header-span__choose_item" *ngIf="selectTargetMode===true" [class.selected]="selectedTask?.task_alias">
    <span  style="color: black;">{{selectedTask?.task_alias? 'Выбрана задача:' : 'Выберите задачу'}}</span>
    <span>{{selectedTask?.task_alias? selectedTask?.task_alias + ' ' +selectedTask?.title : 'Задача не выбрана'}}</span>
  </div>
<span *ngIf="onlyTable!==true" class="header-span">
  <div class="header-span-left-block">
    <mat-form-field class="header-span__filter">
      <mat-label> {{ 'BUTTON_TEXT.SEARCH'|translate }}</mat-label>
      <input [formControl]="textFilterInput" [matTooltip]="'TASKS.TOOLTIPS.USE_CONTEXT_MENU' | translate" matInput
      type="text">
      <button [matTooltip]="'CONTRACTS.BUTTONS.CLEAR'|translate" mat-icon-button matSuffix>
        <mat-icon (click)="textFilterClear()" data-action="textFilterClear">close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="header-span__paginator">
    <button (click)="submitSelectedTarget()"*ngIf="selectTargetMode===true"  data-action="submitSelectedTarget"
      [disabled]="!selectedTask"  class="button-icon size-xl primary-button">
      <mat-icon svgIcon="task-fill"> </mat-icon>
      {{ 'Выбрать' | translate }}
    </button>

    <button (click)="openDialog(createTaskView, 700)"  class="button-icon size-xl outline-button" data-action="onOpenCreateTask" >
      {{ 'TASKS.BUTTONS.CREATE_TASK' | translate }}
      <mat-icon svgIcon="checkbox-line"> </mat-icon>
    </button>


    <ng-container *ngIf="selectTargetMode===false">
      <button (click)="exportToExcel()" data-action="exportToExcel"
        class="button-icon icononly size-xl outline-button" 
        [matTooltip]="'BUTTON_TEXT.TOOLTIPS.EXCEL_EXPORT'| translate " >
        <mat-icon class="header-span__action-button__icon" matSuffix>save_alt</mat-icon>
      </button>
      
      <button (click)="submitQuery(true,true)"  data-action="submitQuery"
        class="button-icon icononly size-xl outline-button"
        [matTooltip]="'BUTTON_TEXT.RELOAD_DATA'| translate "   >
          <mat-icon class="header-span__action-button__icon" matSuffix>refresh</mat-icon>
      </button>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="rowsPerPages" [hidePageSize]="selectTargetMode===true"></mat-paginator>
  </div>
</span>

<div *ngIf="onlyTable!==true" class="filters">
    <span class="filters__overdue-tasks-label">{{ 'TASKS.TOOLTIPS.YOUR_ROLES'|translate }}:</span>
    <mat-button-toggle-group [hideMultipleSelectionIndicator]="true"
                             (change)="complexFilterUserRoleChanged($event.value)" class="filters__user-roles"
                             data-action="complexFilterUserRoleChanged"
                             multiple>
        <mat-button-toggle *ngFor="let item of ROLES_ICONS_MAP | keyvalue" [checked]="true" [value]="item.key">
            <mat-icon [matTooltip]="'TASKS.TEXT.TASK_ROLES.' + item.key | translate" class="filters__user-roles-icon">
                {{ item.value }}
            </mat-icon>
        </mat-button-toggle>
    </mat-button-toggle-group>
    <mat-slide-toggle (change)="complexFilterOverdueChanged($event.checked)" [(ngModel)]="isExpired"
                      class="filters__overdue-tasks" color="secondary"
                      data-action="complexFilterOverdueChanged"
                      labelPosition="before">
        <span class="filters__overdue-tasks-label">{{ 'TASKS.TOOLTIPS.OVERDUE_TASKS'|translate }}</span>
    </mat-slide-toggle>
    <div appearence="fill" class="filters__user-in-task">
        <mat-select (selectionChange)="complexFilterMemberRolesChanged($event.value)"
                    [placeholder]="'TASKS.TOOLTIPS.ROLES_IN_TASK'|translate"
                    class="filters__user-in-task__roles"
                    data-action="complexFilterMemberRolesChanged">
            <mat-option *ngFor="let item of ROLES_ICONS_MAP | keyvalue " [value]="item.key"
                        class="filters__user-in-task__roles__option">
                <mat-icon [matTooltip]="'TASKS.TEXT.TASK_ROLES' + item.key | translate"
                          class="filters__user-in-task__roles__option-icon">
                    {{ item.value }}
                </mat-icon>
                {{ 'TASKS.TEXT.TASK_ROLES.' + item.key | translate }}
            </mat-option>
        </mat-select>
        <mat-select (selectionChange)="complexFilterMemberChanged($event.value)"
                    [placeholder]="('TASKS.TOOLTIPS.USER_WITH_ROLE'|translate) + ' (' + (usersInTasksListFiltered.length||0).toString() + ')'"
                    class="filters__user-in-task__users"
                    data-action="complexFilterMemberChanged">
            <mat-option *ngFor="let item of usersInTasksListFiltered" [value]="item"
                        class="filters__user-in-task__users__option">
                {{ item.full_name }}
            </mat-option>
        </mat-select>
    </div>
    <button (click)="complexFilterReset()" class="filters__reset-button" data-action="complexFilterReset"
            mat-raised-button>
        {{ 'BUTTON_TEXT.RESET_FILTER'| translate }}
        <mat-icon matSuffix>close</mat-icon>
    </button>
</div>

<mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true" *ngIf="onlyTable!==true"
                     [expanded]="false">
    <mat-expansion-panel-header>
        <mat-panel-title>{{ 'LABELS.CUSTOM_FILTER'| translate }}</mat-panel-title>
        <mat-panel-description>
            {{ 'LABELS.EXPAPANSION_PANEL.' + (panelOpenState ? 'CLOSE' : 'OPEN')| translate }}
            <mat-icon style="margin-left: 1vw;">filter_alt</mat-icon>
        </mat-panel-description>
    </mat-expansion-panel-header>
    <form [formGroup]="searchForm" class="complex-search">
      <span class="complex-search_buttons">
        <button (click)="submitQuery(true,true,true)" [disabled]="!this.searchForm.dirty" class="complex-search_buttons_search"
                data-action="submitQuery"
                mat-flat-button>
          {{ 'BUTTON_TEXT.FIND'| translate }}
        </button>
        <button (click)="searchForm.reset();   dataRange.reset();" class="complex-search_buttons_clear"
                data-action="searchForm.reset"
                mat-flat-button>
          {{ 'BUTTON_TEXT.CLEAR'| translate }}
        </button>
      </span>
        <mat-form-field appearance="fill" class="complex-search_date-range">
            <mat-label>{{ 'LABELS.DATE_RANGE_INPUT'| translate }}</mat-label>
            <mat-date-range-input [formGroup]="dataRange" [rangePicker]="picker" [disabled]="true">
                <input [placeholder]="'LABELS.DATE_RANGE.START'| translate" formControlName="dateRangeStart"
                       matStartDate>
                <input [placeholder]="'LABELS.DATE_RANGE.END'| translate" formControlName="dateRangeEnd" matEndDate>
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error
                    *ngIf="dataRange.controls.dateRangeStart.hasError('matDatepickerParse')">{{ 'VALIDATION.DATE_RANGE.START'| translate }}
            </mat-error>
            <mat-error
                    *ngIf="dataRange.controls.dateRangeEnd.hasError('matDatepickerParse')">{{ 'VALIDATION.DATE_RANGE.END'| translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="complex-search_roles-in-task">
            <mat-label>{{ 'LABELS.ROLES_IN_TASK'| translate }}</mat-label>
            <mat-select formControlName="businessRolesListFG" multiple>
                <mat-option (click)="role==='all_roles'? searchFormBusinessRoleToggleAll($event):null"
                            *ngFor="let role of businessRolesList" [selected]="false"
                            [value]="role"
                            data-action="searchFormBusinessRoleToggleAll">
                    {{ 'TASKS.TEXT.TASK_ROLES.' + role|translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="complex-search_bp">
            <mat-label>{{ 'LABELS.BP'| translate }}</mat-label>
            <mat-select formControlName="businessProcessFG" multiple>
                <mat-option *ngFor="let bp of dashes" [selected]="false" [value]="bp">
                    {{ bp.alias }} - {{ bp.description }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-slide-toggle class="complex-search_no_contract" color="secondary" formControlName="contract_is_empty"
                          labelPosition="before">
            <span class="complex-search_no_contract-label">    {{ 'LABELS.TASK_NO_CONTRACT'| translate }}</span>
        </mat-slide-toggle>
    </form>
</mat-expansion-panel>
<div class="table-responsive">
    <table (cdkDropListDropped)="tableDropColumn($event)"
           *ngIf="dataSource" [dataSource]="dataSource" cdkDropList
           cdkDropListOrientation="horizontal"
           data-action="tableDropColumn" mat-table matSort
           multiTemplateDataRows>
        <ng-container *ngFor="let column of columnsToDisplay ; let i=index" [matColumnDef]="column">
            <th *matHeaderCellDef cdkDrag class="task-table_header-cell" mat-header-cell
                mat-sort-header> {{ customPropModels.get(column)?.title || ('TASKS.TITLES2.' + column | translate) }}
            </th>
            <td *matCellDef="let element" [cdkContextMenuTriggerFor]="contextmenu" class="task-table_row-cell" mat-cell>
        <span [ngSwitch]="true===true">
          <p *ngSwitchCase="column==='updated_at'">{{ element[column] | date:'dd/MM/yy, HH:mm:ss' }}</p>
          <p *ngSwitchCase="column==='created_at'">{{ element[column] | date:'dd/MM/yy, HH:mm:ss' }}</p>
          <p *ngSwitchCase="column==='roles'">
            <mat-icon (click)="tableShowUsersInContract(element)" style=" cursor: pointer;"
                      [matTooltip]="'TASKS.TOOLTIPS.MEMBERS_IN_TASK'| translate"
                      class="task-color-icon"
                      data-action="tableShowUsersInContract"
            >supervisor_account</mat-icon>
          </p>
          <p *ngSwitchCase="column==='content'"
             (click)="openContentDialog(element)"
             [matTooltip]="'TASKS.TOOLTIPS.VIEW_CONTENT' | translate"
             style="white-space: nowrap;   overflow: hidden;   text-overflow: ellipsis;   width: 150px !important; cursor: pointer;">
            {{ element['content_desc'] }}
          </p>
          <p *ngSwitchCase="'deadline_at'"
             [class]="element.expired? 'expired-deadline ':''"> {{ element[column] | date:'dd/MM/yy' }} </p>
          <p *ngSwitchCase="column==='user_roles'" class="task-table_row-cell_user_roles">
            <mat-icon *ngFor="let item of element[column]" [matTooltip]="'TASKS.TEXT.TASK_ROLES.' + item | translate"
                      class="task-color-icon">
              {{ ROLES_ICONS_MAP.get(item) }}
            </mat-icon> 
          </p>

          <p *ngSwitchCase="column==='contract_guid'">
            <button mat-icon-button>
              <mat-icon (click)="tableOpenContractForm(element.contract_guid)" *ngIf="element.contract_guid"
                        [matTooltip]="'TASKS.TOOLTIPS.VIEW_CONTRACT' | translate" class="task-color-icon"
                        data-action="tableOpenContractForm">
              description</mat-icon> 
            </button> 
          </p>
          <p *ngSwitchCase="column==='comments_count'">   
              <mat-icon (click)="tableShowComments(element)" *ngIf="element.comments_count"
                        [matTooltip]="'TASKS.TOOLTIPS.VIEW_COMMENTS' | translate"
                        [matBadge]="element.comments_count"
                        class="task-color-icon interactive" data-action="tableShowComments"
                        matBadgeColor="accent" matBadgePosition="above after">
              comment
            </mat-icon>
          </p>
          <p *ngSwitchCase="column==='importance'">
            <button [style.background-color]="IMPORTANTANCE_COLORS.get( element[column])"
                    class="task-table_row-cell_importance"
                    mat-raised-button>
              {{ 'TASKS.TEXT.IMPORTANCE.' + element[column] | translate }} 
            </button>
          </p>
          <p *ngSwitchCase="column==='task_alias'">
            <button (click)="changeTask(element)" [matBadgeHidden]="!element.comments_count"
                    [matBadge]="element.comments_count" class="task-table_row-cell_task_alias"
                    [matTooltip]="'TASKS.TOOLTIPS.OPEN_TASK' | translate"
                    data-action="changeTask" mat-raised-button
                    matBadgeOverlap="true" matBadgePosition="above  after">
            <span class="task-table_row-cell_task_alias_content">
              <mat-icon *ngIf="element.expired" class="task-table_row-cell_task_alias_content_icon" color="warn"
                        matSuffix>
                priority_high
              </mat-icon>    
              <p> {{ element[column] }} </p>
            </span>
            </button> 
          </p>
          <p *ngSwitchCase="column.split('.')[0]==='custom_properties'">
              <span [ngSwitch]="true===true">
              <p *ngSwitchCase="customPropModels.get(column).property_type==='property_file' && customPropModels.get(column).is_multiform ">
                  <a *ngFor="let member of element['custom_properties'][column.split('.')[1]]" [routerLink]=""
                     [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_FILE' | translate"
                     (click)="openFile(member.key)">
                    <span class="link" style="margin-right: 5px;"> {{ member.name }} </span>
                  </a> 
              </p>
              <p *ngSwitchCase="customPropModels.get(column).property_type==='property_file' && customPropModels.get(column).is_multiform==false ">
                  <a [routerLink]="" [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_FILE' | translate"
                     (click)="openFile(element['custom_properties'][column.split('.')[1]].key)">
                    <span class="link"
                          style="margin-right: 5px;"> {{ element['custom_properties'][column.split('.')[1]].name }} </span>
                  </a> 
              </p>
              
              <p *ngSwitchCase="customPropModels.get(column).property_type==='property_member' && customPropModels.get(column).is_multiform ">
                  <a *ngFor="let member of element['custom_properties'][column.split('.')[1]]" [routerLink]=""
                     [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_PROFILE' | translate"
                     (click)="openMember(member.guid)">
                    <span class="link" style="margin-right: 5px;"> {{ member?.lastname || member?.email }} </span>
                  </a> 
              </p>
              <p *ngSwitchCase="customPropModels.get(column).property_type==='property_member' && customPropModels.get(column).is_multiform==false ">
                  <a [routerLink]="" [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_PROFILE' | translate"
                     (click)="openMember(element['custom_properties'][column.split('.')[1]].guid)">
                    <span class="link" style="margin-right: 5px;"> 
                      {{ element['custom_properties'][column.split('.')[1]]?.lastname || element['custom_properties'][column.split('.')[1]]?.email }} 
                    </span>
                  </a> 
              </p>
              <p *ngSwitchCase="customPropModels.get(column).property_type==='property_boolean' ">
                  <mat-checkbox class="checkbox" [(ngModel)]="element[column]"
                                (click)="$event.preventDefault(); element[column]=element[column]"></mat-checkbox>
              </p>
              <p *ngSwitchDefault>
                  {{ element[column] }}
              </p>
              </span>
          </p>
          <p *ngSwitchDefault>
            {{ element[column] }}
          </p>
        </span>
                <ng-template #contextmenu>
                    <div cdkMenu class="menu-context">
                        <button (click)="textFilterUpdate(element[column])" cdkMenuItem
                                class="menu-context-item" data-action="textFilterUpdate">
                            <mat-icon class="menu-icon" matPrefix>filter_list</mat-icon>
                            {{ 'CONTEXT_MENU.FILTER' | translate }}..
                        </button>
                        <button (click)="textFilterClear()" cdkMenuItem
                                class="menu-context-item" data-action="textFilterClear">
                            <mat-icon class="menu-icon" matPrefix>close</mat-icon>
                            {{ 'CONTEXT_MENU.CLEAR_FILTER' | translate }}..
                        </button>
                        <button (click)="onOpenCreateTaskModal(createTaskView)" cdkMenuItem
                                class="menu-context-item" data-action="onOpenCreateTaskModal">
                            <mat-icon class="menu-icon" matPrefix>add</mat-icon>
                            {{ 'CONTEXT_MENU.CREATE' | translate }}..
                        </button>
                        <button (click)="changeTask(element)" cdkMenuItem
                                class="menu-context-item" data-action="changeTask">
                            <mat-icon class="menu-icon" matPrefix>edit</mat-icon>
                            {{ 'CONTEXT_MENU.EDIT' | translate }}..
                        </button>
                    </div>
                </ng-template>
            </td>
        </ng-container>
        <tr *matHeaderRowDef="columnsToDisplay; sticky: true" [class.transparent]="headerTransparent"
            class="task-table_header"
            mat-header-row
        ></tr>
        <tr *matRowDef="let element; columns: columnsToDisplay;let dataindex=dataIndex;" class="task-table_row" mat-row  tabindex=0
          (click)="selectTask(element)"
          [class.selected]="selectedTask?.task_alias===element.task_alias"
          >
        </tr>

    </table>
</div>
<mat-paginator #paginatorBottom *ngIf="rowsPerPages<dataSource.data.length" [pageSizeOptions]="[5, 10, 25, 100]"
               [pageSize]="rowsPerPages"></mat-paginator>

<ng-template #createTaskView let-modal>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.TASK' | translate }}</h2>
        <h3>{{ 'MODALS.FIELDS.TITLE' | translate }}</h3>
        <input #taskName aria-describedby="emailHelp" class="form-control" id="taskName" required>

        <h3 class="mt-2">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h3>
        <div class="task__content mb-3">
            <app-component-ckeditor
                    (emitFinish)="description = $event[1]"
                    [isShowButtons]="false"
                    [isShowEditor]="false">
            </app-component-ckeditor>
        </div>

        <h3 *ngIf="!alias">{{ 'MODALS.FIELDS.BUSINESS_PROCESS' | translate }}</h3>
        <select (change)="selectBoard(selectedDash)" *ngIf="!alias" [(ngModel)]="selectedDash" class="form-select">
            <option *ngFor="let item of dashes" [ngValue]="item"> [{{ item.alias }}] {{ item.name }}</option>
        </select>
          <button (click)="onCreateTask(modal, taskName.value);"
            [disabled]="isLockButton"
            class="button-icon size-xl primary-button" style="margin-top: 12px; margin-bottom: 12px;"
            data-action="onCreateTask">
            <mat-icon svgIcon="checkbox-fill"></mat-icon>
          <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>